<template>
  <el-dialog
    :visible="getVisibleDialog"
    ref="dialog"
    :title="metadataTitle"
    :width="popupWidth"
    :close-on-click-modal="false"
    @close="isEmailForm ? closeEmailDialog() : closeDialog()"
    :class="['dialog', 'general_dialog', { 'email-form': isEmailForm }]"
  >
    <div class="dialog__content" v-loading="clickSaveform || dialogLoading">
      <el-form
        v-if="metaData && metaData.panels"
        :key="formKey"
        ref="form"
        :model="form"
        :rules="rules"
        :class="`dialog-form demo-ruleForm`"
        label-width="100%"
        :label-position="
          getIntentDialog.id && getIntentDialog.id.lastIndexOf('reminder') != -1
            ? 'left'
            : ''
        "
        :size="formSize"
        enctype="multipart/form-data"
      >
        <div
          :class="`dialog-form__section ${section.panel_id} el-form__section`"
          v-for="(section, i) in metaData.panels"
          :key="i"
        >
          <h4 v-if="section.lbl">{{ section.lbl }}</h4>
          <div
            v-for="(row, m) in section.rows"
            :key="`${i}_${m}`"
            class="flex-row"
          >
            <div
              v-for="(item, k) in row"
              :key="`${i}_${m}_${k}`"
              :class="[fieldColumnClass(row, item, k)]"
            >
              <div
                :key="item.label"
                v-if="!item.name && item.type === 'html_label'"
                v-html="$sanitize(item.lbl)"
              ></div>
              <Button
                class="button-admin"
                v-else-if="item.type === 'link'"
                :key="item.label"
                :buttonText="item.lbl"
                disabled
                buttonSize="big"
              />

              <FormButtons
                v-else-if="item.type === 'button'"
                :key="item.id"
                :buttons_menu="[[item]]"
                :disabledBtns="
                  metadataTitle.toLowerCase().indexOf('оффер') >= 0 &&
                  !form['template_name']
                    ? { preview: true, save_and_download: true }
                    : {}
                "
                :topPanel="false"
                @get-intent="getIntentHandler"
                view-type="detail"
              ></FormButtons>

              <div v-else-if="item.type == 'file'" class="email-attachment">
                <p class="el-form-item__label email-attachment__title">
                  {{ item.lbl }}
                </p>
                <Upload
                  ref="upload"
                  class="email-attachment__uploader"
                  :file="files"
                  :multiple="true"
                  :summarySize="20 * 1024 ** 2"
                  :show-file-list="true"
                  @remove-file="removeDocument"
                />
              </div>

              <div v-else-if="item && item.type" class="no-margin">
                <form-field
                  :key="`${i}_${m}_${k}_${updateKey}`"
                  :item="item"
                  :form="form"
                  :options="options"
                  :blocked="blocked"
                  :module="module"
                  :datepicker="datepicker"
                  :model="form"
                  prefix-class="dialog"
                  @set-value="setFieldValue"
                  @change-option="changeOption"
                  @save-form="saveForm"
                ></form-field>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <div class="footer" v-if="metaData.buttons_menu">
        <FormButtons
          v-for="item in metaData.buttons_menu[0]"
          :key="item.id"
          :buttons_menu="[[item]]"
          :topPanel="false"
          view-type="detail"
          :module="module"
          :breakOnSave="breakOnSave(item)"
          @get-intent="addFieldsToForm"
          :needCoordination="needCoordination"
          @email-sent="val => setEmailSent(val)"
        ></FormButtons>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { eventBus } from '@/bus';
import { getController } from '@/controllers/request';
import { store } from '@/store';
import {
  DEFAULT_FORM_SIZE,
  EVENTBUS_EVENTS,
  INTENT_AREA,
  MODULE
} from '@/utils/constants';
import { scrollToError, setDateFormat } from '@/utils/helpers';
import {
  errorMsg,
  form,
  metadata,
  mixin,
  parseIntent,
  rules,
  saveForm
} from '@/utils/mixins';
import Button from 'Elements/Button/Button';
import FormButtons from 'Elements/Form/FormButtons';
import FormField from 'Elements/Form/FormField';
import Upload from 'Elements/Upload/Upload';
import { Dialog, Form } from 'element-ui';

export default {
  mixins: [mixin, form, metadata, saveForm, rules, parseIntent, errorMsg],
  props: {
    metaData: {
      type: Object
    }
  },
  data() {
    return {
      form: {},
      formKey: 0,
      updateKey: 0,
      formSize: DEFAULT_FORM_SIZE,
      options: {},
      blocked: {},
      module: null,
      prefixClass: 'dialog',
      fields: {},
      rules: {
        confirm_new_password: [
          {
            validator: (rule, value, callback) => {
              if (value != this.form['new_password']) {
                callback(new Error('Пароли не совпадают'));
              } else if (value && value.indexOf(' ') >= 0) {
                callback(
                  new Error('Пароль не должен содержать символ пробела')
                );
              } else {
                callback();
              }
            },
            trigger: ['blur', 'focus', 'change']
          }
        ],
        new_password: [
          {
            validator: (rule, value, callback) => {
              if (value && value.indexOf(' ') >= 0) {
                callback(
                  new Error('Пароль не должен содержать символ пробела')
                );
              } else {
                callback();
              }
            },
            trigger: ['blur', 'focus', 'change']
          }
        ]
      },
      loading: false,
      requestUrl: '',
      files: [],
      emailSent: false,
      defaultParams: {},
      dialogLoading: false,
      needCoordination: false,
      datepicker: {
        dateFormat: 'dd.MM.yyyy',
        timeFormat: 'HH:mm'
      }
    };
  },
  created() {
    eventBus.$on(EVENTBUS_EVENTS.FORM_ERROR, () => {
      this.showNotification({
        offset: 100,
        showClose: true,
        message: `Ошибка сохранения формы`,
        duration: 10000,
        type: 'error'
      });
    });
    eventBus.$on(EVENTBUS_EVENTS.CLOSE_POPUP, () => {
      this.isEmailForm ? this.closeEmailDialog() : this.closeDialog();
    });
    eventBus.$on(INTENT_AREA.NEW_HTML_PAGE, this.preview);
    eventBus.$on(EVENTBUS_EVENTS.DOWNLOAD_FILE, data => {
      if (data?.document_id) {
        this.downloadFileFromURL(
          process.env.VUE_APP_BASE_PATH +
            (process.env.VUE_APP_BASE_PATH.lastIndexOf('/') ==
            process.env.VUE_APP_BASE_PATH.length - 1
              ? ''
              : '/') +
            `index.php?entryPoint=download&id=${data.document_id}&type=Documents`
        );
      }
    });
    eventBus.$on(EVENTBUS_EVENTS.EMAIL_SENT, this.setEmailSent);
    eventBus.$on(EVENTBUS_EVENTS.SAVE_REQUEST_FORM, intents =>
      this.saveRequestForm(intents)
    );
  },

  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.FORM_ERROR);
    eventBus.$off(EVENTBUS_EVENTS.CLOSE_POPUP);
    eventBus.$off(INTENT_AREA.NEW_HTML_PAGE, this.preview);
    eventBus.$off(EVENTBUS_EVENTS.DOWNLOAD_FILE);
    eventBus.$off(EVENTBUS_EVENTS.EMAIL_SENT, this.setEmailSent);
    eventBus.$off(EVENTBUS_EVENTS.SAVEFORM, this.saveForm);
  },
  mounted() {
    this.form = {};
    this.fields = this.getBeanDialog;
    this.module = this.$route.meta.module;
    this.processMetadata();

    if (this.metaData.hidden_fields) {
      this.metaData.hidden_fields.forEach(field =>
        this.$set(this.form, field.name, this.formatHtml(field.value))
      );
    }

    if (this.metaData?.user_dat_format) {
      this.$set(
        this.datepicker,
        'dateFormat',
        setDateFormat(this.metaData?.user_dat_format)
      );
    }

    setTimeout(() => {
      this.$refs.form.resetFields();
    }, 0);
  },
  computed: {
    isOpenPositionPopup() {
      return (
        (this.metaData?.title?.main?.length &&
          this.metaData?.title?.main[0]?.lbl?.name == 'LBL_OPEN_POSITION') ||
        false
      );
    },
    isClosePositionPopup() {
      return (
        (this.metaData?.title?.main?.length &&
          this.metaData?.title?.main[0]?.lbl?.name == 'LBL_CLOSE_POSITION') ||
        false
      );
    },
    isEmailForm() {
      return this.metaData?.title && this.metaData?.title.main[0].name
        ? this.metaData?.title.main[0].name == 'LBL_EMAIL_POPUP_TITLE'
        : false;
    },
    popupWidth() {
      return store.state.dialog.size;
    },
    metadataTitle() {
      return this.metaData?.title?.main.length &&
        this.metaData?.title?.main[0]?.lbl?.value
        ? this.metaData.title.main[0].lbl.value
        : this.getIntentDialog &&
          this.getIntentDialog.lbl &&
          this.getIntentDialog.lbl.value
        ? this.getIntentDialog.lbl.value
        : '';
    },
    getIntentDialog() {
      return store.state.dialog.intents;
    },
    getBeanDialog() {
      return store.state.dialog.bean;
    },
    getLoading() {
      return store.state.dialog.loading;
    },
    getVisibleDialog() {
      return store.state.dialog.singleDialogVisible || false;
    },
    clickSaveform() {
      if (store.state.common.clickSaveform) {
        this.addFieldsToForm();
      }
      return store.state.common.clickSaveform;
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(value) {
        store.commit('common/setRequestState', value);
      }
    },
    changeableList() {
      return store.state.candidate.changeableList.list;
    },
    getDetachedForm() {
      return store.state.common.detachedForm;
    },
    rightPanelMode() {
      return store.state.rightPanel.panelMode;
    }
  },
  methods: {
    getIntentHandler(intents) {
      intents.forEach(this.handleIntent);
    },
    handleIntent(intent) {
      if (intent.intentArea == 'Save' && intent.intentType == 'BeanForm') {
        switch (intent.request?.request_params?.mode) {
          case 'preview':
            this.preview(intent);
            break;
          case 'download':
          case 'save_and_download':
            this.downloadFileWithIntent(intent);
            break;
        }
      }
    },
    async saveRequestForm(intents) {
      setTimeout(async () => {
        let formValid = true;
        const isDeleteAction = intents[0].request.url.includes('action=delete');
        this.$refs['form'].validate(valid => {
          if (!valid) {
            formValid = false;
          }
        });
        if (formValid) {
          const { data } = await this.sendFormRequestFromIntent(
            intents[0],
            this.form
          );
          if (data?.errors?.length) {
            data?.errors.forEach(error => {
              this.showNotification({
                offset: 100,
                showClose: true,
                message: error,
                duration: 6500,
                type: 'error'
              });
            });
          } else {
            eventBus.$emit(EVENTBUS_EVENTS.CLOSE_POPUP);
            if (isDeleteAction) {
              this.$router.push(this.$route.meta.parent);
            } else if (
              this.$route.meta.module === MODULE.COORDINATION ||
              this.$route.meta.module === MODULE.HRPAC_COORDINATION_REQUESTS
            ) {
              switch (this.$route.meta.module) {
                case MODULE.COORDINATION:
                  store.dispatch(
                    'coordination/getCoordinationDetailView',
                    this.$route.params.id
                  );
                  eventBus.$emit(EVENTBUS_EVENTS.UPDATE_PLAN);
                  return;
                case MODULE.HRPAC_COORDINATION_REQUESTS:
                  store.dispatch(
                    'coordinationRequest/getCoordinationDetailView',
                    this.$route.params.id
                  );
                  eventBus.$emit(EVENTBUS_EVENTS.UPDATE_PLAN);
                  return;
              }
            }
          }
        }
      }, 100);
    },
    removeDocument(doc, dockList) {
      this.files = dockList;
    },

    selectTemplate(templateId) {
      if (templateId) {
        this.dialogLoading = true;

        getController({
          url: `/index.php?entryPoint=emailTemplateData&emailTemplateId=${templateId}&to_pdf=true${
            this.fields?.parent_type?.value
              ? '&parent_type=' + this.fields?.parent_type?.value
              : ''
          }${
            this.fields?.parent_id?.value
              ? '&parent_id=' + this.fields?.parent_id?.value
              : ''
          }`
        })
          .then(resp => {
            const { data, error } = resp.data;

            if (error) {
              this.showErrorMessage(error);
              return;
            }

            if (data.multiple_values) {
              this.showNotification({
                offset: 100,
                showClose: true,
                message: `Для некоторых переменных найдено несколько значений. Оставьте нужные варианты`,
                duration: 6500,
                type: 'warning'
              });
            }

            if (!data || !data.field_mapping) return;

            for (let key in data.field_mapping) {
              if (key != 'attachments') {
                this.$set(
                  this.form,
                  data.field_mapping[key],
                  this.formatHtml(data[key])
                );
              } else if (
                key == 'attachments' &&
                data[key] &&
                data[key].length
              ) {
                this.$emit('set-template-files', data[key]);

                this.files = [
                  ...this.files.filter(
                    file => !file.type || file.type == 'forward'
                  ),
                  ...data[key].map(f => ({
                    ...f,
                    type: 'template',
                    uid: f.id,
                    size: f.filesize || 0
                  }))
                ];
              }
            }
          })
          .catch(err => {
            this.catchError(
              err,
              'Возникла ошибка выбора шаблона письма',
              'select email template'
            );
          })
          .finally(() => {
            this.dialogLoading = false;
          });
      }
    },
    async preview(intent) {
      this.dialogLoading = true;

      try {
        let errorFields = this.getErrorValidFields(this.$refs.form);
        if (!errorFields.length) {
          const resp = await this.sendFormRequestFromIntent(
            intent,
            intent.intentArea == INTENT_AREA.NEW_HTML_PAGE ? {} : this.form
          );
          if (resp?.data && !resp.data?.errors?.length && resp.data?.fileData) {
            const file = new Blob([this.s2ab(atob(resp.data.fileData))], {
              type: resp.data.fileType
            });
            const windowParams = `location=no,toolbar=no,menubar=no,width=800,height=1000,left=100,top=100`;

            window
              .open(
                URL.createObjectURL(file),
                `Предпросмотр сформированного оффера:blank`,
                windowParams
              )
              .focus();
            URL.revokeObjectURL(file);
          } else if (
            resp?.data &&
            !resp.data?.errors?.length &&
            !resp.data?.fileData
          ) {
            window.open('', '', 'popup').document.write(resp.data);
          } else if (resp?.data?.errors && resp.data.errors.length) {
            this.showErrorMessage(resp.data.errors);
          }
        }
      } catch (err) {
        this.catchError(
          err,
          `Возникла ошибка предпросмотра резюме. Попробуйте еще раз.`
        );
      } finally {
        this.dialogLoading = false;
      }
    },
    breakOnSave(item) {
      return item?.intents && item.intents.length
        ? item.intents[0].intentArea != INTENT_AREA.SAVE
          ? false
          : this.metaData?.panels.length
          ? this.metaData?.panels[0]?.panel_id == 'lbl_communications' ||
            this.metaData?.panels[0]?.panel_id == 'lbl_candidate_save' ||
            this.metaData?.panels[1]?.panel_id ==
              'lbl_rejection_reasons_panel' ||
            this.metaData?.panels[0]?.panel_id == 'change_password' ||
            this.metaData?.panels[1]?.panel_id == 'notify' ||
            this.metaData?.panels[0]?.panel_id == 'change_status' ||
            this.isEmailForm ||
            (this.$route.meta.module == MODULE.COORDINATION &&
              item.intents[0].intentArea == INTENT_AREA.SAVE) ||
            this.metadataTitle.toLowerCase().indexOf('оффер') >= 0
          : false
        : false;
    },
    setEmailSent(value) {
      if (!this.emailSent) this.emailSent = value;
    },

    async getDefaultParams(intent) {
      this.requestUrlgetDefaultParams = '/' + intent.request.url;
      for (const reqProp in intent.request.request_params) {
        let newObject = { [reqProp]: intent.request.request_params[reqProp] };
        this.defaultParams = { ...this.defaultParams, ...newObject };
      }
    },

    async addFieldsToForm(intents) {
      this.dialogLoading = true;
      if (!intents) {
        this.dialogLoading = false;
        return;
      }
      if (this.getIntentDialog?.name === 'HRPAC_CANDIDATES_EXPORT_TO_XLSX') {
        try {
          const resp = await getController({
            url: intents[0].request.url,
            params: {
              ...intents[0].request.request_params,
              fields: this.form?.group_checkbox_button
            }
          });
          if (!resp || !resp.data) return;
          this.downloadFile(resp.data);
        } catch (error) {
          console.error(error);
        } finally {
          this.closeDialog();
        }
      } else if (
        this.getIntentDialog?.name === 'HRPAC_CANDIDATES_SAVE_TO_FILE' ||
        intents[0].id == 'hrpac_candidates_save_to_file'
      ) {
        try {
          await this.sendFormRequestFromIntent(intents[0], {
            format: this.form?.resume_format,
            resume_template: store.state.common.newOptions?.resume_template
              ? store.state.common.newOptions?.resume_template.find(
                  template => template.name == this.form.resume_template
                ).id || ''
              : this.options?.resume_template.find(
                  template => template.name == this.form.resume_template
                ).id || ''
          });
        } catch (error) {
          console.error(error);
        }
      } else if (this.getIntentDialog?.intentArea === INTENT_AREA.CLOSE_POPUP) {
        this.closeDialog();
      } else {
        if (intents[0]?.request?.url?.includes('testOutboundEmail')) {
          intents[0].request.request_params['outboundtest_to_address'] =
            this.form['test_email'] || '';
        }
        store.commit('event/setIntents', intents);
        await this.parse();
      }
      this.dialogLoading = false;
      store.commit('common/setClickSaveform', false);
    },
    handleBlur(visible, name) {
      if (!visible) {
        this.skills[name] = '';
        this.visibleSkillBtn = false;
      }
    },
    async downloadFileWithIntent(intent) {
      return await this.$refs.form.validate(async (valid, fields) => {
        if (!valid) {
          store.commit('common/setClickSaveform', false);
          const errorFields = Object.keys(fields).map(
            field => this.fields[field]
          );
          const wrapperEl =
            this.$refs.form.$el.closest(
              '.dialog--scrollable .el-dialog__body'
            ) ||
            this.$refs.form.$el.closest('.dialog') ||
            window;
          scrollToError(
            errorFields,
            wrapperEl,
            this.defaultParams.module == MODULE.HRPAC_PUBLISHED_VACANCY
              ? `#pane-${this.specialParam}`
              : null
          );
        } else {
          try {
            const resp = await this.sendFormRequestFromIntent(
              intent,
              this.form
            );
            if (resp.data) {
              const file = new Blob([this.s2ab(atob(resp.data.fileData))], {
                type: resp.data.fileType
              });
              const e = document.createElement('a');
              e.href = URL.createObjectURL(file);
              e.target = '_blank';
              e.download = `Оффер_${this.form?.candidate_last_name}_${this.form?.candidate_first_name}_${this.form?.candidate_middle_name}.pdf`;
              document.body.appendChild(e);
              e.click();
              document.body.removeChild(e);
              URL.revokeObjectURL(file);
            } else {
              this.catchError('Возникла ошибка скачивания файла');
            }
          } catch (err) {
            this.catchError(err, 'Возникла ошибка скачивания файла');
          }
        }
      });
    },
    downloadFile(data) {
      let blob = new Blob([this.s2ab(atob(data.fileData))], {
        type: data.fileType
      });
      let url = URL.createObjectURL(blob);
      let a = document.createElement('a');

      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = data.fileName;
      a.click();
      a.remove();
      this.showNotification({
        offset: 100,
        showClose: true,
        message: `Кандидаты экспортированы в XLS формате`,
        duration: 6500,
        type: 'success'
      });
      URL.revokeObjectURL(url);
    },

    s2ab(s) {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;

      return buf;
    },
    downloadFileFromURL(url) {
      const e = document.createElement('a');
      e.href = url;
      e.target = '_blank';
      e.download = url.substr(url.lastIndexOf('/') + 1);
      document.body.appendChild(e);
      e.click();
      document.body.removeChild(e);
    },

    closeEmailDialog() {
      if (!this.emailSent) {
        this.confirmCloseDialog(
          {
            title: 'Закрыть письмо?',
            text: 'При закрытии данные не сохранятся',
            buttons: [
              {
                id: 'cancel',
                name: 'Оставить',
                color: 'transparent',
                reset: false
              },
              {
                id: 'ok',
                name: 'Закрыть',
                color: 'transparent',
                reset: true,
                callback: () => {
                  store.commit('subpanels/setSelectedMessage', null);
                  store.commit('dialog/setRemoveDialogData');
                }
              }
            ]
          },
          true
        );
      } else {
        store.commit('dialog/setRemoveDialogData');
      }
    },
    closeDialog() {
      store.commit('dialog/setRemoveDialogData');
    }
  },
  components: {
    'el-dialog': Dialog,
    'el-form': Form,
    FormField,
    FormButtons,
    Button,
    Upload
  },
  destroyed() {
    store.commit('rightPanel/setParam', {
      name: 'vacancyId',
      val: ''
    });
  },
  watch: {
    'form.new_password': function () {
      this.$refs.form.validateField('confirm_new_password');
    },
    'form.need_coordination': function (newVal) {
      this.needCoordination = newVal == '1' ? true : false;
    }
  }
};
</script>
<style lang="scss" scoped>
#front .dialog {
  & ::v-deep .el-dialog {
    padding: 0;

    &__header {
      padding: 20px 24px !important;
      border-bottom: 1px solid $black-20;
    }

    &__footer {
      width: 100%;
      padding: 20px 24px !important;
      margin-top: 0;
      border-top: 1px solid $black-20;

      .footer {
        width: 230px;
      }
    }
  }
}

.el-dialog {
  text-align: left;
}

.dialog__content {
  // max-height: 100vh;
  max-height: 100%;

  .open {
    display: block;
  }

  .hide {
    display: none;
  }

  &__left {
    background-color: $black-20;
    border-right: 1px solid $black-20;
    width: 293px;
    min-height: 600px;
    overflow: auto;
  }

  .el-form--label-left {
    & ::v-deep .panel-row {
      align-items: center;
    }

    .el-form__section:not(:last-child) {
      border-bottom: 1px solid #e9edf2;
      margin-bottom: 0 !important;
    }

    .el-form__section:first-child {
      padding-bottom: 16px;
    }

    .el-form__section:last-child {
      padding-top: 16px;
    }

    .el-form__section:not(:first-child):not(:last-child) {
      padding: 16px 0;
    }

    & ::v-deep .el-form-item__error {
      display: none;
    }

    .flex-row {
      margin-bottom: 16px;
      gap: 16px !important;

      .dialog-form__section-column--left {
        width: 100%;
      }

      .dialog-form__section-column--right {
        max-width: 216px !important;

        & ::v-deep .el-form-item {
          &__content {
            width: unset !important;

            .el-form-item__label {
              min-width: 0;
              width: unset;
              display: contents;
            }

            .el-input,
            .ck {
              min-width: 120px;
              margin-left: 8px;
            }
          }
        }
      }

      .dialog-form__section-column:nth-child(3) {
        width: 154px !important;
      }

      .dialog-form__section-column:first-child:not(:only-child) {
        & ::v-deep .el-form-item {
          &__content {
            .el-date-editor {
              width: 140px;
            }
          }
        }
      }

      .dialog-form__section-column:nth-child(2) {
        margin-left: auto;
        width: min-content !important;

        & ::v-deep .el-form-item {
          &__content {
            .el-input {
              width: 120px;
            }
          }
        }
      }
    }

    .flex-row:last-child {
      margin-bottom: 0;
    }

    & ::v-deep .row__no-label {
      .el-input {
        margin-left: 0 !important;
      }
    }

    & ::v-deep .el-form-item {
      &__content {
        flex-direction: row;
        display: flex;

        .el-form-item__label {
          white-space: nowrap;
          min-width: 112px;
          width: 112px;
          display: block;
          padding: 0;
        }

        .el-input,
        .ck {
          min-width: 120px;
          margin-left: 16px;
        }

        .ck {
          width: calc(100% - 16px);
        }
      }
    }
  }

  .dialog-form {
    background: #fff;
    border-radius: 6px;
    position: relative;
    overflow: unset;

    .lbl_panel_detail_experience,
    .lbl_panel_summery,
    .lbl_panel_salary,
    .lbl_panel_education,
    .lbl_panel_language_proficiency,
    .lbl_panel_skills_training {
      padding: 12px 24px;
      background-color: $black-10;
      border-radius: 4px;

      h4 {
        margin-top: 0 !important;
        margin-bottom: 10px;
      }

      .dialog-form__section-column--right {
        margin-left: 24px;
      }
    }

    .dialog-form__resume-upload {
      width: 890px;
      margin-right: 32px;

      & ::v-deep .el-upload-dragger {
        height: 200px;
      }
    }

    & ::v-deep .photo-upload {
      top: 40px;
      right: -962px;
    }

    &::-webkit-scrollbar {
      width: 0px !important;
    }

    .el-form__section:not(:last-of-type) {
      margin-bottom: 32px;
    }

    .el-form__section {
      text-align: left;
      h4 {
        color: $black-200;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        margin: 0;
        width: fit-content;
        padding: 0;
        margin-bottom: 16px;
      }

      .flex-row {
        gap: 32px;
        justify-content: space-between;

        .email-attachment {
          margin-top: 12px;

          &__title {
            line-height: 40px;
          }
        }

        .button-admin {
          margin-top: 32px;
        }

        .dialog-form__section-column {
          width: 50%;
          max-width: 544px;
        }

        .dialog-form__section-row {
          width: 100%;
        }

        .el-form-item__content {
          margin-left: 0 !important;
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0 !important;

          .label {
            font-weight: normal;
            font-size: 14px;
            line-height: 24px;
            color: $black-200;
          }
        }

        &:last-child ::v-deep .el-form-item {
          margin-bottom: 0;
        }

        & ::v-deep .el-checkbox,
        & ::v-deep .el-radio {
          max-height: unset;
          height: 28px;
          align-items: center;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.field {
  width: 50% !important;
}

.flex-row {
  display: flex;
  width: 100%;
}

.no-margin {
  padding: 0;
  margin-left: 0;

  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-form-item {
  width: 100%;

  &__error {
    position: relative;
  }

  &__label {
    display: contents;
    width: 100%;
    text-align: left;
  }

  &__content {
    margin-left: 0;
    width: 100%;
  }
}
</style>
